export default function Muse0Text(): JSX.Element {
  return (
    <span className="muse0-text">
      Muse<span>0</span>
    </span>
  );
}
